import { Button, InputNumber } from 'antd';
import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const CardButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 12px;
  color: #262626;
  text-align: start;
  cursor: pointer;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid #f78e1e;
    outline-offset: 2px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const CardTitle = styled.span`
  display: block;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const CardTotal = styled.span`
  flex: none;
  font-size: 14px;
  font-weight: 700;
`;

export const CardSecondary = styled.span`
  font-size: 12px;
  color: #8c8c8c;
`;

export const CardConcept = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const CardDetails = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 12px;
  color: #595959;
`;

export const CardObservation = styled.span`
  font-size: 12px;
  font-style: italic;
  color: #595959;
  overflow-wrap: anywhere;
`;

export const CardTag = styled.span`
  align-self: flex-start;
  padding: 0 8px;
  font-size: 12px;
  line-height: 20px;
  color: #d16d0f;
  background: #fff9eb;
  border: 1px solid #ffd899;
  border-radius: 4px;
`;

export const LoadMore = styled(Button)`
  width: 100%;
  height: 44px;
  margin-top: 8px;
`;

export const Empty = styled.div`
  padding: 24px 0;
`;

export const SheetFields = styled.div`
  .ant-form-item {
    margin-bottom: 14px;
  }

  .ant-select,
  .ant-input,
  .ant-input-number,
  .currency-field input {
    width: 100%;
  }

  .ant-input,
  .ant-input-number,
  .currency-field input,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    min-height: 44px;
  }

  .ant-input-number-input {
    height: 42px;
  }

  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 42px;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 42px;
  }

  .currency-field input {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
`;

export const FieldHint = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
`;

export const QuantityInput = styled(InputNumber)`
  width: 100%;
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;

  > span:first-child {
    color: #8c8c8c;
  }

  > span:last-child {
    font-size: 18px;
    font-weight: 700;
  }
`;

export const SheetActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const SheetAction = styled(Button)`
  width: 100%;
  height: 44px;
`;
